import { render, staticRenderFns } from "./FlagTiles.vue?vue&type=template&id=b0f081e6&scoped=true&"
import script from "./FlagTiles.vue?vue&type=script&lang=js&"
export * from "./FlagTiles.vue?vue&type=script&lang=js&"
import style0 from "./FlagTiles.vue?vue&type=style&index=0&id=b0f081e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f081e6",
  null
  
)

export default component.exports